import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CTAButtonProps = {
  label: string;
  note?: string;
  size?: 'md' | 'lg';
  tone?: 'primary' | 'gold';
  className?: string;
};
export function CTAButton({
  label,
  note,
  size = 'md',
  tone = 'primary',
  className = ''
}: CTAButtonProps) {
  const toneClasses = tone === 'gold' ? 'bg-gold-500 text-navy-950 hover:bg-[#FFD37A] focus-visible:outline-gold-500' : 'bg-brand-500 text-white hover:bg-brand-600 focus-visible:outline-brand-500';
  const sizeClasses = size === 'lg' ? 'px-6 py-5 text-base sm:text-lg' : 'px-5 py-4 text-[0.95rem] sm:text-base';
  return <div className={`w-full ${className}`} data-id="element-29" data-mp="2ypji5ttao411">
      <a href={CHECKOUT_URL} className={`group flex w-full items-center justify-center gap-2 rounded-2xl text-center font-display font-extrabold uppercase leading-tight tracking-tight shadow-[0_14px_34px_-12px_rgba(47,123,255,0.7)] transition-[transform,background-color,box-shadow] duration-150 ease-out hover:-translate-y-0.5 active:translate-y-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 ${toneClasses} ${sizeClasses}`} data-id="element-30" data-mp="2yquu4gww8i38">
        <span className="max-w-[22ch] sm:max-w-none" data-id="element-31" data-mp="1i8tedpexn76i">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-32" data-mp="1n97b4bb32up8" />
      </a>
      {note ? <p className="mt-3 text-center text-[0.72rem] font-medium uppercase tracking-[0.12em] text-slate-400" data-id="element-33" data-mp="1w8ubcts2tugp">
          {note}
        </p> : null}
    </div>;
}